// UX pass 2026-10-25 (bug found in Val's test): a company created without a code (entities.entity_code) later blocks every
// New Staff save with "Home placement needs a 2-5 character uppercase Company/Market/Organization code". The code is the
// start of each employee ID and booking confirmation number, so the app now asks for it at setup and suggests one.
export const ENTITY_CODE_PATTERN = /^[A-Z0-9]{2,5}$/;
export const ENTITY_CODE_RULE = 'Use 2 to 5 capital letters or numbers, for example ATL or RIDE.';

const SKIP_WORDS = new Set(['THE', 'A', 'AN', 'OF', 'AND', 'LLC', 'INC', 'CO', 'CORP', 'LTD']);

export function normalizeEntityCode(value) {
    return String(value ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 5);
}

// A starting suggestion the owner can change: several words -> their initials ("Val Whitney Holdings" -> VWH),
// one word -> its first 4 letters ("DEMO"). Never shorter than 2; a code already used in this company gets a number.
export function suggestEntityCode(name, taken = []) {
    const words = String(name ?? '').toUpperCase().split(/[^A-Z0-9]+/).filter(Boolean);
    const meaningful = words.filter((word) => !SKIP_WORDS.has(word));
    const source = meaningful.length ? meaningful : words;
    let code = source.length >= 2 ? source.map((word) => word[0]).join('').slice(0, 5) : (source[0] || '').slice(0, 4);
    code = normalizeEntityCode(code);
    if (code.length < 2) code = normalizeEntityCode(`${code}CO`).slice(0, 3);
    const used = new Set(taken.map((item) => String(item || '').toUpperCase()));
    if (!used.has(code)) return code;
    for (let n = 2; n < 100; n += 1) {
        const candidate = `${code.slice(0, 5 - String(n).length)}${n}`;
        if (!used.has(candidate)) return candidate;
    }
    return code;
}
